import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../environments/environment';

export type PublicResourceType = 'profile';

@Pipe({
  name: 'publicResourceUrl',
})
export class PublicResourceUrlPipe implements PipeTransform {
  transform(fileName: string | undefined, expertId: string, resourceType: PublicResourceType): string {
    if (!fileName || !expertId) {
      return '';
    }
    return `${environment.urlConfig.userContentBucketUrl}/${expertId}/${resourceType}/${fileName}`;
  }
}
